import { Button as AntButton } from 'antd';
import React from 'react';
import { ButtonType } from '../../constants/style';
import * as Styled from './Button.styled';

export interface IButtonProps
  extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'type'> {
  type?: ButtonType;
  loading?: boolean;
  as?: any;
  href?: string;
  target?: string;
  htmlType?: 'button' | 'submit' | 'reset';
  fullWidth?: boolean;
  className?: string;
}

const Button = (props: IButtonProps) => {
  const {
    as,
    type,
    disabled,
    loading,
    children,
    className,
    htmlType,
    fullWidth,
    ...rest
  } = props;
  const extendProps = {};
  if (!as || as === AntButton) {
    Object.assign(extendProps, {
      htmlType: htmlType,
      shape: 'round',
    });
  }
  return (
    <Styled.Button
      as={as}
      $type={type}
      $fullWidth={fullWidth}
      disabled={disabled}
      loading={loading}
      className={className}
      {...extendProps}
      {...rest}
    >
      {children}
    </Styled.Button>
  );
};

Button.defaultProps = {
  type: ButtonType.PRIMARY,
  fullWidth: false,
  htmlType: 'button',
};

export default Button;
